import { useEffect, useRef } from 'react';
import { initKlaviyo, trackViewedProduct } from '@/lib/klaviyo';

/**
 * Hook to initialize Klaviyo on app load
 * Uses the company ID defined in src/lib/klaviyo.ts
 */
export function useKlaviyoInit() {
  const initialized = useRef(false);
  
  useEffect(() => {
    if (!initialized.current) {
      initKlaviyo();
      initialized.current = true;
    }
  }, []);
}

/**
 * Hook to track product views for Browse Abandonment flow
 */
export function useKlaviyoProductView(product: {
  id: string;
  title: string;
  handle: string;
  vendor?: string;
  productType?: string;
  price: number;
  compareAtPrice?: number;
  currencyCode?: string;
  imageUrl?: string;
} | null) {
  const trackedRef = useRef<string | null>(null);

  useEffect(() => {
    if (!product || trackedRef.current === product.id) return;

    // Track the view
    trackViewedProduct({
      productId: product.id,
      productName: product.title,
      productUrl: `${window.location.origin}/product/${product.handle}`,
      imageUrl: product.imageUrl || '',
      price: product.price,
      compareAtPrice: product.compareAtPrice,
      currencyCode: product.currencyCode || 'SEK',
      vendor: product.vendor,
      categories: product.productType ? [product.productType] : undefined,
    });

    trackedRef.current = product.id;
  }, [product]);
}
